import React from 'react';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Security as SecurityIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  userInfoCard: {
    backgroundColor: '#ffffff',
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(2),
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
  },
  accessOverviewIcon: {
    marginRight: theme.spacing(1),
    color: '#6366f1',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  statsGrid: {
    marginTop: theme.spacing(2),
  },
  statCard: {
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: '#f9fafb',
    borderRadius: theme.spacing(1),
    border: '1px solid #e5e7eb',
  },
  statNumber: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#374151',
  },
  statLabel: {
    fontSize: '0.875rem',
    color: '#6b7280',
    fontWeight: 500,
  },
}));

interface Stat {
  label: string;
  count: number;
  color: string;
}

interface AccessOverviewProps {
  hasAicoeSuperUser: boolean;
  permissionStats: Stat[];
}

export const AccessOverview: React.FC<AccessOverviewProps> = ({
  hasAicoeSuperUser,
  permissionStats,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.userInfoCard}>
      <CardContent>
        <div className={classes.headerContent}>
          <SecurityIcon className={classes.accessOverviewIcon} />
          <Typography variant="h5" style={{ fontWeight: 600, color: '#374151' }}>
            Access Overview
          </Typography>
        </div>
        <Typography variant="body1" color="textSecondary" paragraph>
          {hasAicoeSuperUser
            ? '🌟 You have AiCOE Marketplace Super Admin access with full permissions to AICOE Marketplace.'
            : '📋 Below are your current permissions across accessible products. You can request additional write or admin access where needed.'}
        </Typography>

        <Grid container spacing={2} className={classes.statsGrid}>
          {permissionStats.map((stat, index) => (
            <Grid item xs={hasAicoeSuperUser ? 12 : 4} key={index}>
              <div className={classes.statCard}>
                <Typography className={classes.statNumber} style={{ color: stat.color }}>
                  {stat.count}
                </Typography>
                <Typography className={classes.statLabel}>{stat.label}</Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};
